<template>
  <div class="login-container" dir="rtl">
    <div class="animated-background">
      <div class="floating-elements">
        <span class="element code">{ }</span>
        <span class="element book">📚</span>
        <span class="element graduation">🎓</span>
        <span class="element tech">💻</span>
        <span class="element atom">⚛️</span>
        <span class="element formula">∑</span>
        <span class="element infinity">∞</span>
        <span class="element binary">01</span>
        <span class="element circuit"></span>
        <span class="element grid"></span>
      </div>
    </div>
    
    <v-card class="login-card" elevation="0">
      <div class="content-wrapper">
        <!-- Logo Side -->
        <div class="logo-side">
          <img src="@/assets/soufara.png"  alt="Logo" class="logo" />
          <div class="brand-text">
            <h2 class="welcome-text">مرحباً بك في</h2>
            <h1 class="brand-name">سفراء العلم</h1>
          </div>
        </div>

        <!-- Form Side -->
        <div class="form-side">
          <h3 class="form-title">تسجيل الدخول</h3>
          
          <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit" class="login-form">
            <v-text-field
              v-model="form.username"
              label="اسم المستخدم"
              :rules="[v => !!v || 'اسم المستخدم مطلوب']"
              variant="outlined"
              prepend-inner-icon="mdi-account"
              class="rtl-input"
              density="comfortable"
              bg-color="white"
              hide-details="auto"
            ></v-text-field>

            <v-text-field
              v-model="form.password"
              label="كلمة المرور"
              :rules="[v => !!v || 'كلمة المرور مطلوبة']"
              type="password"
              variant="outlined"
              prepend-inner-icon="mdi-lock"
              class="rtl-input"
              density="comfortable"
              bg-color="white"
              hide-details="auto"
            ></v-text-field>

            <v-btn
              type="submit"
              block
              :loading="loading"
              class="action-btn"
              size="large"
            >
              دخول
              <v-icon end icon="mdi-arrow-left" class="mr-1"></v-icon>
            </v-btn>
          </v-form>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'LoginView',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      loading: false,
      valid: true
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    async handleSubmit() {
      if (!this.$refs.form.validate()) return;
      
      this.loading = true;
      try {
        await this.login(this.form);
        this.$router.push('/dashboard');
      } catch (error) {
        this.$store.dispatch('showAlert', {
          message: 'خطأ في تسجيل الدخول',
          type: 'error'
        });
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<!-- Login styles are now handled globally in src/assets/styles/global.css -->
<style scoped>
.login-form {
  max-width: 380px;
  margin: 0 auto;
  width: 100%;
}

.content-wrapper {
  display: flex;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
  width: 50vw;
  height: 50vh;
  min-height: 500px;
  min-width: 900px;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

.logo {
  width: 250px;
  height: auto;
  margin-bottom: 24px;
  filter: brightness(0) invert(1);
  animation: float 6s ease-in-out infinite;
}

/* RTL Specific Styles */
:deep(.v-field__input) {
  text-align: right !important;
}

:deep(.v-label) {
  right: 16px !important;
  left: auto !important;
}

:deep(.v-input__prepend) {
  margin-left: 8px !important;
  margin-right: -4px !important;
}

/* Responsive */
@media (max-width: 1200px) {
  .content-wrapper {
    width: 70vw;
    min-width: auto;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    width: 90vw;
    height: auto;
    min-height: auto;
    flex-direction: column;
  }
  
  .logo {
    width: 180px;
  }
}
</style>
